<ckeditor
  class="apm-editor"
  [editor]="Editor"
  [config]="defaultConfig"
  [data]="initialValue()"
  [formControl]="$any(form())"
  (blur)="onBlur($event)"
></ckeditor>
